import { ArrowRightTopIcon } from './ArrowRightTopIcon';

/**
 * author: Colton Wiscombe
 * id 0FD8FA03-2B86-4B8E-8650-075591AC024C
 * name arrow-right-top
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right-top.svg
 * tags
 */
export const TurnRightIcon = ArrowRightTopIcon;
export default TurnRightIcon